<template>
  <div>
    <v-menu bottom left>
      <template v-slot:activator="{ on, attrs }">
        <v-badge bordered overlap offset-y="20" offset-x="30" :content="locale">
          <v-btn light icon v-bind="attrs" v-on="on">
            <v-icon>mdi-earth</v-icon>
          </v-btn>
        </v-badge>
      </template>

      <v-list>
        <v-list-item :class="langSwitcherClass('fr')">
          <v-list-item-subtitle>
            <a @click="changeLocale('fr')">fr</a>
          </v-list-item-subtitle>
        </v-list-item>
        <v-list-item :class="langSwitcherClass('en')">
          <v-list-item-subtitle>
            <a @click="changeLocale('en')">en</a>
          </v-list-item-subtitle>
        </v-list-item>
        <v-list-item :class="langSwitcherClass('nl')">
          <v-list-item-subtitle>
            <a @click="changeLocale('nl')">nl</a>
          </v-list-item-subtitle>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>

export default {
  name: "LangMenu",
  methods: {
    langSwitcherClass(locale) {
      return this.locale === locale ? "primary white--text" : "white";
    },
    changeLocale(locale) {
      this.$store.dispatch("changeLocale", locale).then(() => {
        this.$emit("on-change-locale");
      });
    }
  },
  props: {
    locale: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.white--text a {
  color: white;
}

.nav-item span {
  padding: 0 8px;
}
</style>